// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Preloader_loaderContainer__yhcvB","loaderBox":"Preloader_loaderBox__zWRbe","loader":"Preloader_loader__Pipji","load8":"Preloader_load8__Q-MgQ"};